import { object, string, InferType } from 'yup';

import { damageReportFieldNames } from 'src/pages/DamageReportPage/constants';

export const thirdPartyDetailsSchema = object().shape({
  [damageReportFieldNames.thirdPartyLicenseNumber]: string().required().nullable(),
});

export type ThirdPartyDetailsSchemaType = InferType<typeof thirdPartyDetailsSchema>;
